import type { i18n, TFunction } from 'i18next';

import { type Bonus, BonusStage, type Freespin } from '@/api/common';

export const PERCENTS_100 = 100;
export const BONUS_REF_PARAM = 'bonus-ref';
export const PROMO_HEADER_OFFSET = 72;

export const getBonusStatusNameTranslation = (
  t: TFunction,
  i18n: i18n,
  stage: BonusStage,
  plainText?: boolean
) => {
  const stageName = stage === BonusStage.HandleBets ? 'active' : stage;

  const translation = i18n.exists(`bonuses:bonusStatuses.${stageName}`)
    ? t(`bonuses:bonusStatuses.${stageName}`)
    : stageName;

  const translationSplitted = translation.split('\n');

  if (plainText) return translationSplitted.join(' ');

  return translationSplitted.map((item, index) => (
    <span key={index}>
      {item}
      {index < translationSplitted.length - 1 && <br />}
    </span>
  ));
};

export function isBonus(bonus: Bonus | Freespin): bonus is Bonus {
  return (bonus as Bonus).amountCents !== undefined;
}

export function getRandomDouble(min: number, max: number) {
  return +(Math.random() * (max - min + 1) + min).toFixed(2);
}
